var translationKey = 'faqs.description';
var hft = {
    drawerActionButton: null,
    certificateBalance: true,
    certificateExpirationDays: 90,
    certificateValue: 5,
    disclaimerTranslationKey: 'hftDisclaimer',
    es: {
        termsAndConditionsLink: 'https://apply.syf.com/cs/groups/public/documents/et_statusdoc/e096332.html'
    },
    en: {
        termsAndConditionsLink: 'https://apply.syf.com/cs/groups/public/documents/et_statusdoc/e096332.html'
    },
    howToEarnPointsHeader: 'fullDetailsPage.howToEarnPointsHeader',
    faqsSnapshot: true,
    isRewardTiers: false,
    isValuePropBanner: true,
    links: [],
    translationViewPrintKey: null,
    PRIVATE_LABEL: {
        actionButton: null,
        banner: 'hft-banner-PLCC-md.png',
        bannerSm: 'hft-banner-PLCC-sm.png',
        cashRewardsBalance: false,
        certificateHistoryImg: 'hft-banner-PLCC-md.png',
        certificateHistoryImgSm: 'hft-banner-PLCC-sm.png',
        certificateHistory: true,
        faqs: 'https://harborfreight.com/credit',
        rewardsBalance: true,
        snapshotTranslationKey: translationKey,
        translationKey: translationKey,
        valuePropImg: 'hft-valuePropPrivateLabel-sm.png',
        en: {
            propositions: [
                {
                    description: 'Earn 5% back in Harbor Freight Money every time you shop.*',
                    heading: 'earn',
                    points: '5% back'
                }
            ]
        },
        es: {
            propositions: [
                {
                    description: 'Obtenga un 5% de reembolso en Harbor Freight Money con cada compra.*',
                    heading: 'obtenga',
                    points: '5% de reembolso'
                }
            ]
        }
    }
};
export default hft;
